import { secFormat } from "@/utils";

/**
 * el-table 中 column 的格式工具集
 */

export default {
    methods: {
        /// 去除时间中的秒
        timeNoSec(row, column, cellValue, index) {
            let defaultVal = this.defaultVal(row, column, cellValue, index)
            if (defaultVal === "--") return defaultVal
            return cellValue.slice(0, 16)
        },
        defaultVal(row, column, cellValue, index) {
            if (cellValue == null || cellValue === "" || cellValue.length === 0 || cellValue === "1753-01-01 00:00:00") {
                return "--"
            } else {
                return cellValue
            }
        },
        secFormat(row, column, cellValue, index) {
            return secFormat(cellValue)
        }
    },
}
